import React from 'react';

import FieldLabel from './FieldLabel';
import FieldStatusText from './FieldStatusText';
import FlexRow from './FlexRow';
import FormGroup from './FormGroup';
import Textarea from './Textarea';

type Props = React.ComponentProps<typeof Textarea> & {
    name: string;
    value: string;
    onChange: (ev: any) => void;
    label?: string;
    placeholder?: string;
    autoFocus?: boolean;
    required?: boolean;
    error?: string;
    counter?: number;
};

const FormInput = React.forwardRef<HTMLTextAreaElement, Props>(({ onChange, ...props }, ref) => {
    const valueLength = props.counter != null && (props.value == null ? 0 : props.value.length);

    const handleChange = (ev) => {
        if (props.counter != null) {
            const len = ev.target.value.length;
            if (len > props.counter) {
                return;
            }
        }

        onChange(ev);
    };

    return (
        <FormGroup itemsSpacing={5}>
            <FlexRow justify="space-between">
                <FieldLabel>{props.label}</FieldLabel>
                <FieldLabel>
                    {props.counter != null && `${valueLength}/${props.counter}`}
                </FieldLabel>
            </FlexRow>
            <Textarea ref={ref} style={{ fontSize: '1.6rem' }} onChange={handleChange} {...props} />
            <FieldStatusText status="error">{props.error}</FieldStatusText>
        </FormGroup>
    );
});

export default FormInput;
